import React from "react";

export default function Terms() {
  return (
    <main className="min-h-screen bg-[#080b12] text-gray-200 px-5 py-24">
      <article className="max-w-4xl mx-auto">
        <p className="text-red-500 uppercase tracking-widest text-sm mb-4">
          Doriantelive // Legal
        </p>
        <h1 className="text-4xl font-bold text-white mb-4">
          Terms of Service
        </h1>
        <p className="text-gray-400 mb-12">Effective October 28, 2026</p>

        <div className="space-y-8 leading-8">
          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">1. Acceptance</h2>
            <p>
              By using doriantelive.com or its services, including Stream
              Control, you agree to these Terms of Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">2. Services</h2>
            <p>
              Doriantelive provides streaming management tools, creator
              features, member functionality, and related services.
              Stream Control is currently provided without a subscription fee.
              Third-party services may impose their own charges or limitations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">3. Account Responsibility</h2>
            <p>
              Users must connect only accounts and channels they own or
              are authorized to manage. Users are responsible for protecting
              their accounts and reviewing changes made through Stream Control.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">4. Third-Party Platforms</h2>
            <p>
              Integrations with YouTube, Twitch, and Kick remain subject
              to the respective platforms' terms, policies, and API restrictions.
              YouTube users are also subject to the
              {" "}<a href="https://www.youtube.com/t/terms" className="text-red-400 underline" target="_blank" rel="noreferrer">YouTube Terms of Service</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">5. Acceptable Use</h2>
            <p>
              Users must not use the service for unauthorized access,
              fraudulent activity, unlawful conduct, interference with
              service operations, or violations of third-party platform rules.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">6. Content Ownership</h2>
            <p>
              Users retain their existing rights to content they own.
              Connecting a streaming account does not transfer ownership
              of the account or its content to Doriantelive.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">7. Availability</h2>
            <p>
              Services are provided on an as-available basis and may be
              interrupted, modified, or discontinued. Third-party API
              changes may affect available features.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">8. Purchases</h2>
            <p>
              Where merchandise or paid features are offered, applicable
              prices, taxes, shipping costs, and other purchase details
              will be presented during checkout. Additional purchase
              and refund conditions may apply.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">9. Updates and Contact</h2>
            <p>
              These terms may change as the service develops.
              Questions may be directed to
              {" "}<a href="mailto:mail@doriantelive.com" className="text-red-400 underline">mail@doriantelive.com</a>.
            </p>
          </section>
        </div>
      </article>
    </main>
  );
}
